module.exports = __webpack_public_path__ + "static/img/hassle-free-process.7ac15040.svg";